<div class="header-main" [ngSwitch]="ctx.FooterTemplate">
  <app-footer-default [ctx]="ctx" *ngSwitchDefault></app-footer-default>
  <app-footer-xtraparts [ctx]="ctx" *ngSwitchCase="'xtraparts'"></app-footer-xtraparts>
  <app-footer-roskamp [ctx]="ctx" *ngSwitchCase="'roskamp'"></app-footer-roskamp>
  <app-footer-excluparts *ngSwitchCase="'excluparts'"></app-footer-excluparts>
</div>